// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"7c14c4cb","365":"01aa3be1","374":"4ae9bfdb","415":"c336a72f","672":"a8ad9970","682":"ae687c77","837":"3c242a77"}[chunkId] + ".chunk.js";
};